import React from 'react';
import { Tag } from 'antd';
import { defineMessage, FormattedMessage, MessageDescriptor } from 'react-intl';
import styled, { css } from 'styled-components';
import {
  RefundStatus,
  TransactionStatus,
} from 'utils/apiClient/services/shorepay/types';

export const statusDisplayText: Record<
  TransactionStatus | RefundStatus,
  MessageDescriptor
> = {
  canceled: defineMessage({
    defaultMessage: 'Cancelled',
    description: 'transaction status',
  }),
  succeeded: defineMessage({
    defaultMessage: 'Successfull',
    description: 'transaction status',
  }),
  pending: defineMessage({
    defaultMessage: 'Processing',
    description: 'transaction status',
  }),
  in_progress: defineMessage({
    defaultMessage: 'Processing',
    description: 'transaction status',
  }),
  failed: defineMessage({
    defaultMessage: 'Failed',
    description: 'transaction status',
  }),
  refunded: defineMessage({
    defaultMessage: 'Refunded',
    description: 'transaction status',
  }),
};

interface StatusTagProps {
  status: TransactionStatus | RefundStatus;
}
const StatusTag = styled(({ status, ...rest }: StatusTagProps) => (
  <Tag {...rest}>
    {statusDisplayText[status] ? (
      <FormattedMessage {...statusDisplayText[status]} />
    ) : (
      ''
    )}
  </Tag>
))`
  border: none;
  margin: 0;
  color: rgba(0, 0, 0, 0.65);
  background-color: rgba(0, 0, 0, 0.04);
  ${(p) =>
    p.status === 'refunded' &&
    css`
      color: #fff;
      background-color: orange;
    `};
  ${(p) =>
    (p.status === 'canceled' || p.status === 'failed') &&
    css`
      color: #fff;
      background-color: #ff2e52;
    `};
`;
export default StatusTag;
